export default __webpack_public_path__ + "static/media/logo.69109bf2.png";